import React from "react";
import { useSelector } from "react-redux";
import { numberMask } from "../../../../../../../../services/helpersMethodsService";
import { CardSupplementSupplyPerDietDashboardTableContainer } from "./styles";
import useLotDetailsSupplementSupplyContext from "../../../../../../../../hooks/useLotDetailsSupplementSupplyContext";

// import { Container } from './styles';

function CardSupplementSupplyPerDietDashboard() {
  const { supplementSuppliedPerDiet } = useLotDetailsSupplementSupplyContext();
  const { translation } = useSelector((state) => state.app);
  return (
    <CardSupplementSupplyPerDietDashboardTableContainer>
      <table>
        <thead>
          <tr>
            <th>
              <span>
                {
                  translation.lot.production.details.supplementSupply.dashboards
                    .columns.diet
                }
              </span>
            </th>
            <th>
              <span>
                {
                  translation.lot.production.details.supplementSupply.dashboards
                    .columns.days
                }
              </span>
            </th>
            <th>
              <span>
                {
                  translation.lot.production.details.supplementSupply.dashboards
                    .columns.amountSupplied
                }
              </span>
            </th>
            <th>
              <span>
                {
                  translation.lot.production.details.supplementSupply.dashboards
                    .columns.cost
                }
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {supplementSuppliedPerDiet.map((supplement) => {
            return (
              <tr key={supplement.dietName}>
                <td>{supplement.dietName}</td>
                <td>{supplement.days}</td>
                <td>{numberMask(supplement.amountSupplied, false)}</td>
                <td>{numberMask(supplement.totalCost, true)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </CardSupplementSupplyPerDietDashboardTableContainer>
  );
}

export default CardSupplementSupplyPerDietDashboard;
